<template>
    <BasicTile class="profile-card">

        <UserProfileHeader></UserProfileHeader>

        <v-divider></v-divider>

        <UserInformation></UserInformation>
        
        <v-divider></v-divider>

        <ProfileStats></ProfileStats>

    </BasicTile>
</template>



<script setup lang="ts">

import ProfileStats from "./Profile-Stats.vue";
import UserInformation from "./User-Information.vue";
import UserProfileHeader from "./User-Profile-Header.vue";
import BasicTile from "@/components/Tiles/Basic-Tile.vue";

</script>